import React, { useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux";
import { apiEndpoint } from "helpers/url_helper";
import { Link } from "react-router-dom";
import logoLightPng from "../../assets/images/Logo.png"





// Pages Components
// import Miniwidget from "./Miniwidget"
// import MonthlyEarnings from "./montly-earnings";
// import EmailSent from "./email-sent";
// import MonthlyEarnings2 from "./montly-earnings2";
// import Inbox from "./inbox";
// import RecentActivity from "./recent-activity";
// import WidgetUser from "./widget-user";
// import YearlySales from "./yearly-sales";
// import LatestTransactions from "./latest-transactions";
// import LatestOrders from "./latest-orders";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { AvForm, AvField } from "availity-reactstrap-validation";




import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import { useState } from "react";
import { JsonWebTokenError } from "jsonwebtoken";
import { values } from "lodash";
import { func } from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";


function DeviceList(props) {

    const [modal, setModal] = useState(false)
    const [LocationList, setLocationList] = useState([]);
    const [HardwareDetailsList, setHardwareDetailsList] = useState([]);

    const [FormValues, setFormValues] = useState({ CampusID: '', LocationID:'', CampusName: '', LocationName: '', ControllerIPAddress: '', CameraIPAddress: '', MacAddress: '' });
    const [modal_small, setmodal_small] = useState(false);
    const [basic, setbasic] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const[validateMsg, setvalidateMsg] = useState();


  function checkIfValidIP(str) {
    // Regular expression to check if string is a IP address
    const regexExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi;
  
     if(!regexExp.test(str))
     {
        setvalidateMsg("Ip Address is Invalid");
        console.log(validateMsg);
     }
  }



    

    useEffect(() => {
        // UserValidated
        fetch(apiEndpoint+"/getLocationDetails",
            {
                mode: "cors",
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    //'Access-Control-Allow-Origin': '*',
                  },
                body: JSON.stringify({
                    "strToken": sessionStorage.getItem("Clear_AuthUser")
                    
                  })
            }
        )
            .then(res => res.json())
            .then((data) => {
                //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))
                setLocationList(data.LocationDetails)
            });

            // UserValidated
            fetch(apiEndpoint+"/getHardwareDetails",
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                  },
                body: JSON.stringify({
                    "strToken": sessionStorage.getItem("Clear_AuthUser")
                    
                  })
            }
        )
            .then(res => res.json())
            .then((data) => {

               setHardwareDetailsList(data.HardwareDetails)
               //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))
            });
    

    },[]);


    const [EditedLocationName, setEditedLocationName] = useState();
    const [editLocationValues, seteditLocationValues] = useState();
    const [editControllerIP, seteditControllerIP] = useState();
    const [editCameraIP, seteditCameraIP] = useState();
    const [editRadarIP, seteditRadarIP] = useState();
    const [editMacAddress, seteditMacAddress] = useState();
    const [editLatitude, setditLatitude] = useState();
    const [editLongitude, seteditLongitude] = useState();


    const[EditResponseMessage, setEditResponseMessage] = useState();
    const[EditResponseMessageType, setEditResponseMessageType] = useState();
    

    const SaveEditLocDetails = () => {
        // UserValidated
        fetch(apiEndpoint+'/SaveEditedData',
            {
                mode: "cors",
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    //'Access-Control-Allow-Origin': '*',
                },
                body:JSON.stringify( {
                    "intLocationID": FormValues.LocationID,
                    "strLocationName":editLocationValues,
                    "strControllerIP":editControllerIP,
                    "strCameraIP":editCameraIP,
                    "strMacAddress":editMacAddress,
                    "strLatitude": editLatitude,
                    "strLongitude": editLongitude,
                    "strRadarIP": editRadarIP,
                    "strToken": sessionStorage.getItem("Clear_AuthUser")
                    
                })


            }
        )
        .then(res => res.json())
        .then((data) =>{
            setEditResponseMessage(data.ResponseMessage); 
            setEditResponseMessageType(data.ResponseType); 

            if(data.ResponseType == "success")
            {
                setbasic(true);
                setModalOpen(false);
               
            }
        })
    }

    const DeviceDetailsList = () =>{
        debugger;
        window.location.reload();
        // UserValidated
        fetch(apiEndpoint+'/getLocationDetails',
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Allow-Origin': '*',

                },
                body: JSON.stringify({
                  "strToken": sessionStorage.getItem("Clear_AuthUser")
                  
                })
            })
            .then(res => res.json())
            .then((data) => {
                debugger;
               
                setLocationList(data.LocationDetails);
                //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))
            });

    }

    const refreshPage = ()=>{
        window.location.reload();
     }

     function validateIpAddress(value) {
        const ipAddressRegex =/^(\d+\.\d+\.\d+\.){1}\d+$/;
        if (!ipAddressRegex.test(value)) {
          return "Invalid IP address";
        }
        const ipAddressRegex1 = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (!ipAddressRegex1.test(value)) {
          return "Invalid IP address";
        }
    
    
        return true;
      }
    
      
    function isValidLatitude(value) {
      const latRegex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
    
      if(!latRegex.test(value))
      {
        return "Invalid Latitude Value";
      }
      else{
        return true;
      }
    }
    
    function isValidLongitude(value) {
      const lonRegex = /^[-+]?([1-9]?\d(\.\d+)?|1[0-7]\d(\.\d+)?|180(\.0+)?)$/;
      if(!lonRegex.test(value))
      {
        return "Invalide Longitude Value"
      }
      return true;
    }

    const getColor = (LocationStatus) => {
        debugger;
        if (LocationStatus === "Online") return 'green';
        if (LocationStatus === "Offline") return 'red';
       
    };

    return (
        <React.Fragment>

{basic ? (
        <SweetAlert
        type={EditResponseMessageType}
          title={EditResponseMessage}
          onConfirm={() => {
            {DeviceDetailsList}
            setbasic(false)
            setModal(!modal)
            
            console.log(EditResponseMessageType)
          }}
        />
      ) : null}
            <Modal
                size="lg"
                isOpen={modal}
                toggle={() => setModal(!modal)}
                style={{width:"500px", height: "500px"}}
            >
                <ModalHeader
                    toggle={() => setModal(!modal)}

                >
                    Edit Device
                    <div className="col-md-6">
                            <input
                                className="form-control"
                                type="hidden"
                                defaultValue={FormValues.LocationID}
                               

                            />
                        </div>
                </ModalHeader>
                <AvForm onValidSubmit={SaveEditLocDetails}
                > 
                <ModalBody>

              
    <Row className="mb-3">
                        <label
                            htmlFor="example-email-input"
                            className="col-md-4 col-form-label"
                        >
                            Location
                        </label>
                        <div className="col-md-8">
                            <AvField
                                className="form-control"
                                type="text"
                                name="Location Name"                        
                                placeholder="Location Name"
                     
                       errorMessage="This text field is required"
                       validate={{
                         required: { value: true },
                         pattern: { value: "/^[A-Za-z0-9_-]+$/", errorMessage: "Only Alphabets Please" },
                       }}
                                value={FormValues.LocationName}
                                onChange={(event) => {
                                    seteditLocationValues(event.target.value);

                                }}

                            />
                        </div>
                    </Row>
                   

                    <Row className="mb-3">
                        <label
                            htmlFor="example-email-input"
                            className="col-md-4 col-form-label"
                        >
                            Controller IP
                        </label>
                        <div className="col-md-8">
                            <AvField
                                className="form-control"
                                type="text"
                                name="Controller IP"                        
                                placeholder="Controller IP Address"
                     
                       errorMessage="This text field is required"
                       validate={{
                        required: { value: true },
                        pattern:{ value:"/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi", errorMessage:"Invalid IP Address" }
                      
                       }}
                                value={FormValues.ControllerIPAddress}
                                onChange={(event) => {
                                    seteditControllerIP(event.target.value);
                                }}
                            />
                        </div>
                    </Row>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-email-input"
                            className="col-md-4 col-form-label"
                        >
                            Camera IP
                        </label>
                        <div className="col-md-8">
                            <AvField
                                     className="form-control"
                                     type="text"
                                     name="Camera IP"                        
                                     placeholder="Camera IP Address"
                                     validate={{ custom: validateIpAddress }}

                                value={FormValues.CameraIPAddress}
                                onChange={(event) => {
                                    seteditCameraIP(event.target.value);
                                  
                                  

                                }}
                            />
                        </div>
                    </Row>


                    <Row className="mb-3">
                        <label
                            htmlFor="example-email-input"
                            className="col-md-4 col-form-label"
                        >
                            Radar IP
                        </label>
                        <div className="col-md-8">
                            <AvField
                                     className="form-control"
                                     type="text"
                                     name="Camera IP"                        
                                     placeholder="Radar IP Address"
                                     validate={{ custom: validateIpAddress }}

                                value={FormValues.RadarIPAddress}
                                onChange={(event) => {
                                    seteditR(event.target.value);
                                  
                                  

                                }}
                            />
                        </div>
                    </Row>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-email-input"
                            className="col-md-4 col-form-label"
                        >
                            MAC Address
                        </label>
                        <div className="col-md-8">
                            <AvField
                                  className="form-control"
                                  type="text"
                                  name="Mac Address"                        
                                  placeholder="MAC Address"
                                  maxLength ="12"
                         errorMessage="This text field is required"
                         validate={{ required: { value: true },
                         minLength: { value: 12, errorMessage: "Invalid MAC Address" },
                         pattern: { value: "[0-9a-f]{2}([-:]?)[0-9a-f]{2}(\\1[0-9a-f]{2}){4}$", errorMessage: "Invalid MAC Address" },
                        }}

                                defaultValue={FormValues.MacAddress}
                                onChange={(event) => {
                                    seteditMacAddress(event.target.value);
                                }}
                            />
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-email-input"
                            className="col-md-4 col-form-label"
                        >
                            Latitude
                        </label>
                        <div className="col-md-8">
                        <AvField
                                  className="form-control"
                                  type="text"
                                  name="Latitude"                        
                                  placeholder="Latitude"
                       
                         errorMessage="This text field is required"
                         validate={{ custom: isValidLatitude }}

                                defaultValue={FormValues.Latitude}
                                onChange={(event) => {
                                    setditLatitude(event.target.value);
                                }}
                            />
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-email-input"
                            className="col-md-4 col-form-label"
                        >
                            Longitude
                        </label>
                        <div className="col-md-8">
                        <AvField
                                  className="form-control"
                                  type="text"
                                  name="Longitude"                        
                                  placeholder="Longitude"
                       
                         errorMessage="This text field is required"
                         validate={{ custom: isValidLongitude }}

                                defaultValue={FormValues.Longitude}
                                onChange={(event) => {
                                    seteditLongitude(event.target.value);

                                }}
                            />
                        </div>
                    </Row>
                </ModalBody>
               
                <ModalFooter >
                    <div className="col-md-offset-4">
                    <button type="reset" className="btn btn-primary  w-md"  onClick={() => setModal(!modal)} >Cancel</button>

                    </div>
                    <div className="">
                    <button className="btn btn-primary w-md" type="submit" onClick={refreshPage} >Submit Changes</button> 

                    </div>
                </ModalFooter>
                </AvForm> 

            </Modal>
            <Row>
                <Col lg={12}>
                  
                    <Card>
                        <CardBody>

                            <div className="table-responsive">
                                <Table className="table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Device ID</th>
                                            <th>Campus</th>
                                            <th>Location</th>
                                            <th>Controller IP</th>
                                            <th>Camera IP</th>
                                            <th>Radar IP</th>
                                            <th>Mac Address</th>
                                            <th>Actions</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {LocationList.map(i =>
                                            <tr>
                                                <td>{i.LocationID}</td>
                                                <td>{i.CampusName}</td>
                                                <td style={{ color: getColor(i.LocationStatus) }}>{i.LocationName}</td>
                                                <td>{i.ControllerIPAddress}</td>
                                                <td>{i.CameraIPAddress}</td>
                                                <td>{i.RadarIPAddress}</td>
                                                <td>{i.MacAddress}</td>

                                                <td> <Link 
                                                    onClick={() => {
                                                        setModal(true)
                                                        setFormValues(i);
                                                       
                                                    }}
                                                    >
                                                       <i className="mdi mdi-border-color mdi-24px"/>
                                                    </Link>
                                                    </td>

                                            </tr>
                                        )}


                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>


            </Row>
            {/* <Row>
                <h3>Hardware Details</h3>
            </Row>
            <Row>
                <Col lg={12}>
                    <Card>
                        <CardBody>

                            <div className="table-responsive">
                                <Table className="table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Status ID</th>
                                            <th>Location </th>
                                            <th>CPU Temprature</th>
                                            <th>CPU Usage</th>
                                            <th>Total RAM</th>
                                            <th>Total Disk Usage</th>
                                            <th>Last Updated Time</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {HardwareDetailsList.map(i =>
                                            <tr>
                                                <td>{i.StatusID}</td>
                                                <td>{i.LocationName}</td>
                                                <td>{i.CpuTemp}</td>
                                                <td>{i.CpuUsage}</td>
                                                <td>{i.TotalRAM}</td>
                                                <td>{i.TotalDiskUsage}</td>
                                                <td>{i.TimeStamp}</td>


                                               

                                            </tr>
                                        )}


                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>


            </Row> */}
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(DeviceList);